import { UnitConverter } from '../base/UnitConverter';
import { UnitOptions } from '../constants/unit.options';

export class CurrentUnitConverter extends UnitConverter<
  (typeof UnitOptions)['Current'][number]['value']
> {
  // 싱글턴 인스턴스
  private static instance: CurrentUnitConverter;

  private constructor() {
    super();
  }

  static getInstance(): CurrentUnitConverter {
    if (!CurrentUnitConverter.instance) {
      CurrentUnitConverter.instance = new CurrentUnitConverter();
    }
    return CurrentUnitConverter.instance;
  }

  protected units = ['milliampere (mA)', 'ampere (A)'] as const;

  protected unitToBase = {
    'milliampere (mA)': 0.001,
    'ampere (A)': 1,
  };
}
